import React, { useEffect } from "react";
import styles from "./AnalysisMap.module.css";
import renderMap from "./chart";
import * as d3 from "d3";
import socio from "../../../../data/socio";

const normal = (d) =>
  d.toLowerCase().split("'").join("").split(" ").join("").split("/")[0].trim();

const AnalysisMap = ({ data }) => {
  const neighborhoods = Array.from(
    d3.rollup(
      data,
      (v) => {
        return {
          total: v.length,
          perCapita:
            (v.length / +socio[normal(v[0].communityarea)].population) * 10000,
        };
      },
      (d) => d.communityarea
    )
  );

  const highestPerCapita = d3.max(neighborhoods, (d) => d[1].perCapita),
    highestTotal = d3.max(neighborhoods, (d) => d[1].total),
    per_capita_neighborhood = neighborhoods.filter(
      (d) => d[1].perCapita === highestPerCapita
    )[0],
    total_neighborhood = neighborhoods.filter(
      (d) => d[1].total === highestTotal
    )[0];

  const totalHomicideKey = (
    <div id="homicide_map_key" className={styles.Key}>
      <p className={styles.SmallValue}>1</p>
      <div className={styles.Circles}>
        <span className={styles.Circle_One}></span>
        <span className={styles.Circle_Two}></span>
        <span className={styles.Circle_Three}></span>
      </div>
      <p className={styles.SmallValue}>25 homicides</p>
    </div>
  );

  const perCapitaKey = (
    <div id="per_capita_key" className={styles.PerCapitaKeyContainer}>
      <p>Homicides per 10,000 people</p>
      <div className={styles.PerCapitaKey}>
        <p className={styles.SmallValue}>1</p>
        <div className={styles.Gradient}>
          <span className={styles.Color_One} />
          <span className={styles.Color_Two} />
          <span className={styles.Color_Three} />
          <span className={styles.Color_Four} />
          <span className={styles.Color_Five} />
        </div>
        <p className={styles.SmallValue}>
          <span id="perPersonMax" />
        </p>
      </div>
      <div className={styles.Color_Zero_Container}>
        <span className={styles.Color_Zero} /> No Homicides
      </div>
    </div>
  );

  useEffect(() => renderMap(data));

  return (
    <div id="homicide_container" className={styles.AnalysisMap}>
      <div className={styles.Desc}>
        <p>
          In 2021 homicide rates have been highest per capita in{" "}
          {per_capita_neighborhood[0]} with{" "}
          {per_capita_neighborhood[1].perCapita.toFixed(1)} homicides per 10,000
          people. {total_neighborhood[0]} has the highest total homicides with{" "}
          {total_neighborhood[1].total} homicides.
        </p>
      </div>
      {totalHomicideKey}
      {perCapitaKey}
      <div id="homicide_map_buttons" className={styles.Btns}>
        <button className="total_homicides">Total Homicides</button>
        <button className="per_capita">Per Capita</button>
      </div>
      <div id="covid_salestax_map" className={styles.Map}>
        <svg
          className="map_container"
          viewBox="0 0 600 800"
          preserveAspectRatio="xMinYMin slice"
          width="100%"
          height="100%"
        ></svg>
        <p className={[styles.places, styles.ohare].join(" ")}>
          O' Hare
          <br />
          International
          <br />
          Airport
        </p>
        <p className={[styles.places, styles.austin].join(" ")}>Austin</p>
        <p className={[styles.places, styles.lincolnpark].join(" ")}>
          Lincoln
          <br />
          Park
        </p>
        <p className={[styles.places, styles.loop].join(" ")}>Loop</p>
        <p className={[styles.places, styles.hydepark].join(" ")}>
          Hyde
          <br />
          Park
        </p>
        <p className={[styles.places, styles.englewood].join(" ")}>Englewood</p>
      </div>
    </div>
  );
};

export default AnalysisMap;
